'use strict';

angular.module('selfAccessRequestControllers')

.controller('ArrivalPreAuthorizedDeltaBySystemTypeController',
            ['$scope', '$state', '$stateParams', '$timeout', 'selfAccessRequestService', 'selfAccessRequest', 'decisionSystemTypesList', 'decisionBySystemType', 'processStep',
    function ($scope, $state, $stateParams, $timeout, selfAccessRequestService, selfAccessRequest, decisionSystemTypesList, decisionBySystemType, processStep) {

     var DECISIONS_TOTAL = decisionSystemTypesList.length;
     var CURRENT_INDEX_SYSTEMTYPE = 0;

     $scope.currentUserId = selfAccessRequest.EmployeeID;

     // Update UI with right column sizes and set CurrentSystemSlug
     updatePreAuthorizedElements($stateParams.systemTypeSlug);

     // Assigning variables for Views
     $scope.currentSystemTypes = decisionSystemTypesList;
     $scope.currentSystemType = decisionBySystemType;

     $scope.processStep = processStep;

        // Skip Pre Authorized
        $scope.skipPreAuthorized = function () {

                selfAccessRequestService
                 .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'PreAuthorized')
                 .then(function (data) {
                     $state.go('selfAccessRequest', {
                         userAccessRequestId: $stateParams.userAccessRequestId
                     }, {
                             reload: true
                     });
                     });
        }


     // Go to selected System Type
     $scope.goToSystemType = function (systemType) {
         $state.go('selfAccessRequest.arrival.preAuthorizedBySystemType', {
             systemTypeSlug: systemType.Slug
         });
     }

     // Go to the next available systemType
     $scope.goToNextSystemType = function () {
         CURRENT_INDEX_SYSTEMTYPE = CURRENT_INDEX_SYSTEMTYPE + 1;
         if (CURRENT_INDEX_SYSTEMTYPE > ($scope.currentSystemTypes.length - 1))
             CURRENT_INDEX_SYSTEMTYPE = 0;
         $scope.goToSystemType($scope.currentSystemTypes[CURRENT_INDEX_SYSTEMTYPE]);

     }

     // Go to the previous available systemType
     $scope.goToPreviousSystemType = function () {
         CURRENT_INDEX_SYSTEMTYPE = CURRENT_INDEX_SYSTEMTYPE - 1;
         if (CURRENT_INDEX_SYSTEMTYPE < 0)
             CURRENT_INDEX_SYSTEMTYPE = $scope.currentSystemTypes.length - 1;
         $scope.goToSystemType($scope.currentSystemTypes[CURRENT_INDEX_SYSTEMTYPE]);
     }

     // Confirm Current System Decisions
     $scope.confirmSystemDecisions = function () {
         var currentUserSystemRoleDecisionList = new Array();
         _.forEach($scope.currentSystemType.SystemList, function (sysListItem) {
             _.forEach(sysListItem.UserSystemRoleDecisionList, function (decision) {
                 currentUserSystemRoleDecisionList.push(decision);
             })
         })

         selfAccessRequestService
          .confirmUserSystemRoleDecisionList($stateParams.userAccessRequestId, currentUserSystemRoleDecisionList)
          .then(function (data) {
              $scope.currentSystemType.IsCompleted = true;

              var NEW_CURRENT_INDEX_SYSTEMTYPE = CURRENT_INDEX_SYSTEMTYPE;

              for (var i = 0; i < $scope.currentSystemTypes.length; ++i) {
                  var idx = (i + CURRENT_INDEX_SYSTEMTYPE) % $scope.currentSystemTypes.length;
                  if (!$scope.currentSystemTypes[idx].IsCompleted) {
                      NEW_CURRENT_INDEX_SYSTEMTYPE = idx
                  }

              }
              $scope.isLastSystemType = _.every($scope.currentSystemTypes, {
                  'IsCompleted': true
              });;
              if (!$scope.isLastSystemType) {
                  $scope.goToNextSystemType();
              }
          })
     }

     // Confirm all systemtypes and Confirm Step
     $scope.confirmAll = function () {
         selfAccessRequestService
          .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'preAuthorized')
          .then(function (data) {
              $state.go('selfAccessRequest', {
                  userAccessRequestId: $stateParams.userAccessRequestId}, {
                  reload: true
              });

          });
     }

     // Go to Arrival HomePage
     $scope.goToArrival = function () {
         $state.go('selfAccessRequest', {
             userAccessRequestId: $stateParams.userAccessRequestId
         }, {
             reload: true
         });
     }

     //Helpers
     function updatePreAuthorizedElements(systemTypeSlug) {
         $(decisionSystemTypesList).each(function (i, e) {
             if (e.Slug === systemTypeSlug) {
                 e.ColumnSize = calcColumnWidthSelected(DECISIONS_TOTAL);
                 e.InProgress = true;
                 CURRENT_INDEX_SYSTEMTYPE = i;
             } else {
                 e.ColumnSize = calcColumnWidthUnselected(DECISIONS_TOTAL);
                 e.InProgress = false;
             }
         });
     }

     function calcColumnWidthUnselected(totalColumns) {
         // Define the column sizes of the header based on total systems types
         var columnSizes = {
             5: 2,
             4: 2,
             3: 3,
             2: 5,
             1: 11
         };

         if (totalColumns > 5) {
             return 1;
         } else {
             return columnSizes[totalColumns];
         }
     }

     function calcColumnWidthSelected(totalColumns) {

         var columnSizes = {
             8: 4,
             7: 5,
             6: 6,
             5: 3,
             4: 4,
             3: 3,
             2: 6,
             1: 11
         };

         if (totalColumns > 8) {
             return 3;
         } else {
             return columnSizes[totalColumns];
         }
     }

 }
]);